import { inject } from '@angular/core';
import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { EMPTY } from 'rxjs';
import { InactivityService } from '../services/inactivity.service';

export const SessionExpiredInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const inactivityService = inject(InactivityService);

  if (inactivityService.sessionExpired()) {
    return EMPTY;
  }

  return next(req);
};
